import React from 'react';

const items = [
  'Body Contouring',
  'Skin Care',
  'Nails',
  'Body Sculpting',
  'Post-Op Care',
  'Facials',
  'Lymphatic Massage',
  'Garland, TX'
];

const Marquee = () => {
  const row = [...items, ...items];

  return (
    <div
      className="marquee bg-black text-white py-6 overflow-hidden select-none"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="marquee-item">
            {i % 2 === 0 ? (
              <span className="font-display italic font-light text-2xl md:text-3xl">{item}</span>
            ) : (
              <span className="text-xs md:text-sm uppercase tracking-[0.3em] text-gray-400">{item}</span>
            )}
            <span className="marquee-star" aria-hidden="true"></span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
